// Unit price after any active sale-collection discount.
export const getEffectivePrice = (item) => {
  const config = item.configuration;
  const configDiscount = config?.Sale?.collectionConfiguration?.discount || 0;
  const discountActive =
    config && configDiscount && config.Sale?.configStatus === "active";

  if (discountActive) {
    // Discount applies to the sale price when there is one, else the regular price
    return (item.salePrice || item.regularPrice) * (1 - configDiscount / 100);
  }
  return item.salePrice || item.regularPrice;
};

// Display amount with two decimals and comma thousands separators, e.g. 12,345.00
export const formatPrice = (amount) =>
  Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
